import React from "react";

const YoutubeIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_368_367)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.9653 5.99167C17.8697 5.63838 17.6833 5.3163 17.4245 5.05749C17.1657 4.79869 16.8436 4.6122 16.4903 4.51658C15.1969 4.16384 9.99152 4.16384 9.99152 4.16384C9.99152 4.16384 4.78584 4.17452 3.49246 4.52726C3.13916 4.62288 2.81708 4.80938 2.55829 5.0682C2.2995 5.32701 2.11302 5.64911 2.01743 6.00241C1.62622 8.30049 1.47446 11.8022 2.02818 14.0084C2.12377 14.3617 2.31025 14.6838 2.56905 14.9426C2.82784 15.2014 3.14991 15.3879 3.5032 15.4835C4.79658 15.8362 10.0021 15.8362 10.0021 15.8362C10.0021 15.8362 15.2076 15.8362 16.5009 15.4835C16.8542 15.3879 17.1763 15.2014 17.4351 14.9426C17.6939 14.6838 17.8804 14.3617 17.976 14.0084C18.3887 11.7071 18.5158 8.20752 17.9653 5.99173V5.99167Z",
  fill: "#FF0000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.33472 7.49879V12.5012L12.6531 10L8.33472 7.49879Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_368_367"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.6667,
  height: 11.6723,
  fill: "white",
  transform: "translate(1.66663 4.16384)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(YoutubeIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;